import { render, staticRenderFns } from "./DocsDownload.vue?vue&type=template&id=625cb016&"
import script from "./DocsDownload.vue?vue&type=script&lang=js&"
export * from "./DocsDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports